var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLocalePtPt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 3H9.75V21H3.75C2.094 21 0.75 19.656 0.75 18V6C0.75 4.344 2.094 3 3.75 3Z",
    fill: "#2B6519"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 21H9L9 3H20.25C21.906 3 23.25 4.344 23.25 6L23.25 18C23.25 19.656 21.906 21 20.25 21Z",
    fill: "#EA3323"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 15.75C11.0711 15.75 12.75 14.0711 12.75 12C12.75 9.92893 11.0711 8.25 9 8.25C6.92893 8.25 5.25 9.92893 5.25 12C5.25 14.0711 6.92893 15.75 9 15.75Z",
    fill: "#FFFF55"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9214 10.1467L7.07764 10.1422V12.7155C7.08064 13.2195 7.28089 13.6957 7.64239 14.0557C8.01064 14.4225 8.49139 14.625 8.99614 14.625C9.50914 14.625 9.99214 14.4247 10.3559 14.0625C10.7196 13.6995 10.9206 13.218 10.9206 12.7065V10.1467H10.9214Z",
    fill: "#EA3323"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocalePtPt);
export default __webpack_public_path__ + "static/media/icon-locale-pt-PT.ac23400168f60b2249b48d5ea2b066f0.svg";
export { ForwardRef as ReactComponent };